import axios from '../modules/AxiosInstance';
import Environment from '../modules/Environment';
import store from '../store';
import UriUtils from '../modules/UriUtils';
import { PAYIT_TENANT_USER_ID, } from '../modules/Constants';

const SDKService = (() => {
  const service = {};
  const BASE_URL = `${Environment.getBaseURL()}`;

  const getSDKPaymentsBySearch = (criteria) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    const queryString = UriUtils.toQueryString(criteria);
    return axios.get(`${BASE_URL}/sdk-payment/search${queryString}`, {
      headers,
    });
  };

  const getAllSDKServiceOfferings = () => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    return axios.get(`${BASE_URL}/sdk-offerings`, {
      headers,
    });
  };

  service.getSDKPaymentsBySearch = getSDKPaymentsBySearch;
  service.getAllSDKServiceOfferings = getAllSDKServiceOfferings;

  return service;
})();

export default SDKService;
